module.exports = __webpack_public_path__ + "static/kredi-862e8975e8e58f1b720285b24d4a2241.svg";